import { render, staticRenderFns } from "./allAdd.vue?vue&type=template&id=e8a08924&scoped=true"
import script from "./allAdd.vue?vue&type=script&lang=js"
export * from "./allAdd.vue?vue&type=script&lang=js"
import style0 from "./allAdd.vue?vue&type=style&index=0&id=e8a08924&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8a08924",
  null
  
)

export default component.exports